import {useState, useEffect, useContext} from "react";
import './contact.scss';
import Button from "../Button/Button";
import LanguageContext from "../../Contexts/Language";

type ContactProps = {
    scrollTop: number
    height: number
}
const Contact = (props: ContactProps) =>{
    const {language} = useContext(LanguageContext);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() =>{
            setIsVisible((props.scrollTop / (6092 / (window.outerWidth / window.innerWidth))) > 5500 / 6092)
    },[props.scrollTop])

    return(
        <div className="contact-container" style={{height: `${props.height}px`}}>
            <div className="contact-container-header">{language.contact.title}</div>
            <div className={`media-container is-media-visible-${isVisible}`}>
                {language.contact.contacts.map((contact, key) => (
                    <div className="contact blur-background" key={key}>
                        <div className="contact-header">
                            <div className="contact-name">{contact.name}</div>
                            <img src={`${process.env.PUBLIC_URL}/${contact.svg}`} alt={`${contact.name}_svg`}/>
                        </div>
                        <div className="contact-description">{contact.description}</div>
                        <Button className="contact-button" href={contact.link} style={contact.style}>{contact.button}</Button>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default Contact